import { api } from '@api/client'
import {
  cached,
  makeKey,
  TWELVE_HOURS_MS
} from '@cache/requestCache'

export function getAssets (companyId) {
  const url = `/company/${companyId}/assets`
  const key = makeKey(url, {})

  return cached(
    key,
    async () => {
      const response = await api.get(url)
      return response.data
    },
    TWELVE_HOURS_MS
  )
}

export function getAssetById ({ companyId, siteId, assetId }) {
  const url = `/company/${companyId}/sites/${siteId}/assets/${assetId}`
  const key = makeKey(url, {})

  return cached(
    key,
    async () => {
      const response = await api.get(url)
      return response.data
    },
    TWELVE_HOURS_MS
  )
}
